{
    "mainProgressBar": {
        "search": "Пошук",
        "deliveryOptions": "Варіанти доставки",
        "recServices": "Рекомендовні послуги",
        "booking": "Бронювання",
        "verification": "Верифікація"
    },
    "orderForm": {
        "title": "Замовити транспорт ще ніколи не було так легко",
        "deliveryFrom": {
            "title": "Доставка з",
            "description": "Звідки ви доставляєте?"
        },
        "deliveryTo": {
            "title": "Доставка в",
            "description": "Куди ви доставляєте?"
        },
        "loadingItem": {
            "title": "Завантаження",
            "description": "Що ви відправляєте"
        },
        "buttons": {
            "tariffSearch": "Пошук тарифів"
        },
        "deliveryInput": {
            "countryFrom": "Країна відправлення",
            "countryTo": "Країна отримання",
            "zipFrom": "Індекс відправлення",
            "zipTo": "Індекс отримання",
            "cityFrom": "Місто відправлення",
            "cityTo": "Місто отримання",
            "zipCityFrom": "Місто/Індекс відправлення",
            "zipCityTo": "Місто/Індекс отримання",
            "countryPlaceholder": "Виберіть країну",
            "cityPlaceholder": "Введіть місто",
            "zipCityPlaceholder": "Введіть місто або індекс",
            "zipOrAddress": "Поштовий індекс або адреса"
        },
        "loadingInput": {
            "tabTitles": {
                "partialLoading": "LTL Часткове завантаження",
                "fullLoading": "FTL Повне завантаження"
            },
            "buttons": {
                "addLoad": "Додати вантаж"
            },
            "partialLoading": {
                "cargoTypeTitle": "Тип вантажу",
                "cargoTypeValues": {
                    "cardboardBox": "Картонна коробка",
                    "euroPallet": "Європіддон (EUR 1,2x0,8)",
                    "palletFin": "Піддон (Fin 1,2x1,0)",
                    "palletInd": "Піддон (Ind 1,2x1,2)",
                    "other": "Інше"
                },
                "loadingWithTailLift": "Вантажівка з гідробортом",
                "cargoDescription": {
                    "title": "Опис вантажу",
                    "placeholder": "Опишіть свій товар"
                },
                "submitSummaryInfo": "* - поля обов'язкові для заповнення"
            },
            "fullLoading": {
                "selectPresetTitle": "Виберіть готові параметри:",
                "orSetManually": "або задайте їх вручну",
                "bodyType": {
                    "title": "Тип кузова",
                    "placeholder": "Виберіть тип кузова",
                    "options": {
                        "bus": "Бус/фургон",
                        "tent": "Тент",
                        "tentCurtain": "Тент-штора",
                        "isotherm": "Ізотерм",
                        "refrigerator": "Рефрижератор",
                        "flatbed": "Бортовий",
                        "flatbedTent": "Борт-тент",
                        "containerCarrier": "Контейнеровоз",
                        "dumpTruck": "Самоскид",
                        "fullMetalVan": "Цільнометалевий фургон",
                        "mega": "Мега (збільшений об'єм)"
                    }
                },
                "carryingCapacity": {
                    "title": "Вантажопідйомність",
                    "placeholder": "1000 тон"
                },
                "loadingMetersLdm": {
                    "title": "Погрузочні метри LDM",
                    "placeholder": "10 метрів"
                },
                "loadingMethod": {
                    "title": "Спосіб завантаження",
                    "placeholder": "Виберіть спосіб завантаження",
                    "options": {
                        "rear": "Задній",
                        "side": "Боковий",
                        "top": "Верхній"
                    }
                },
                "presets": {
                    "bus1100": {
                        "title": "Бус/фургон до 1100 кг",
                        "subtitle": "4-6 європіддонів"
                    },
                    "truck3500": {
                        "title": "Вантаж до 3500 кг",
                        "subtitle": "14 європіддонів"
                    },
                    "truck5000": {
                        "title": "Вантаж до 5000 кг",
                        "subtitle": "18-20 європіддонів"
                    },
                    "truck24000": {
                        "title": "Фура до 24000 кг",
                        "subtitle": "33 європіддони"
                    }
                },
                "loadingWithTailLift": "Вантажівка з гідробортом",
                "adrDangerousGoods": "Містить небезпечний вантаж ADR",
                "cargoDescription": {
                    "title": "Опис вантажу",
                    "placeholder": "Опишіть свій товар"
                },
                "shippingDate": "Дата відправки",
                "costOfCargo": "Вартість вантажу",
                "submitSummaryInfo": "* - поля обов'язкові для заповнення"
            }
        }
    },
    "deliveryOptions": {
        "termDateLbl": "Термін",
        "loadingDateLbl": "Завантаження",
        "deliveryDateLbl": "Доставка",
        "routeChangedWarning": "Ви змінили країну або індекс. Тариф і додаткові послуги скинуто, тому потрібно знову обрати варіант доставки.",
        "termDataValue_one": "{{range}} день",
        "termDataValue_many": "{{range}} днів",
        "termDataValue_few": "{{range}} днів",
        "standard": {
            "title": "Стандарт",
            "subtitle": "Надійно та економно",
            "p1": "Оптимальна ціна для планової доставки",
            "p2": "Надійне перевезення у стандартні терміни",
            "p3": "Підтримка на кожному етапі — телефоном, у чаті та email",
            "p4": "Відстеження відправлення 24/7",
            "button": "Обрати Стандарт"
        },
        "premium": {
            "title": "Преміум",
            "subtitle": "Швидше та з пріоритетом",
            "badge": "Оптимальний вибір",
            "p1": "Швидша доставка з пріоритетним завантаженням",
            "p2": "Оберіть фіксовану дату завантаження та/або доставки",
            "p3": "Зберігання до 3 діб — доставимо у зручний для вас день",
            "p4": "Підтримка на кожному етапі — телефоном, у чаті та email",
            "p5": "Відстеження відправлення 24/7",
            "button": "Обрати Преміум"
        },
        "individual": {
            "title": "Прямий рейс",
            "subtitle": "Максимальна швидкість за вашим графіком",
            "p1": "Окремий автомобіль лише для вашого відправлення",
            "p2": "Пряма доставка без консолідації з іншими вантажами",
            "p3": "Точні дати завантаження та доставки обираєте ви",
            "p4": "Максимальна швидкість і контроль на кожному етапі",
            "costValue": "Індивідуальний розрахунок",
            "button": "Отримати розрахунок"
        }
    },
    "recommendedServices": {
        "title": "Персоналізуйте свое транспортування",
        "additionalServicesLbl": "Додаткові послуги",
        "customsServicesLbl": "Митні послуги",
        "cargoServicesLbl": "Послуги по вантажу",
        "option": {
            "INS": {
                "title": "Страхування вантажу",
                "tooltipTxt": "Страхування вантажу. Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії.",
                "content": "Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії."
            },
            "ADR": {
                "title": "Перевезення небезпечного вантажу (ADR)",
                "tooltipTxt": "Обробка вантажів ADR включає наступні класи: 3, 5.1, 5.2, 6.1, 8, 9. Пропозиція не поширюється на класи ADR 2.1, 2.2, 2.3, 4.1, 4.2, а також на вантажі підвищеної небезпеки, перераховані тут . Для отримання індивідуальних пропозицій на вищевказані вантажі, будь ласка, зв'яжіться з вашим співробітником Vega.",
                "content": "Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії."
            },
            "EX1": {
                "title": "Експортне оформлення",
                "tooltipTxt": "Експортне оформлення. Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії. Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії. Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії.",
                "content": "Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії."
            },
            "IM40": {
                "title": "Імпортне оформлення",
                "tooltipTxt": "Імпортне оформлення. Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії.",
                "content": "Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії."
            },
            "T1": {
                "title": "Сертифікат EUR1",
                "tooltipTxt": "Сертифікат EUR1.Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії.",
                "content": "Lorem Ipsum є текст-заповнювач зазвичай використовується в графічних, друк та видавничої індустрії."
            },
            "LW": {
                "title": "Вікно завантаження",
                "tooltipTxt": "Завантаження здійснюється протягом 2 днів з дати, вказаної у вибраному тарифі. Завантаження в точно зазначену дату можливе лише в тарифі 'Індивідуал'. Також ви можете обрати додаткову послугу 'Вікно завантаження', якщо вам потрібно, щоб ваш вантаж забрали до обіду(9:00-13:00) або після обіду(13:00-17:00).",
                "datePickerName": "Дата завантаження",
                "cargoTimeName": "Час відправки",
                "switchName": "Обрати часи відправки"
            },
            "DW": {
                "title": "Вікно доставки",
                "tooltipTxt": "У цьому варіанті доставки дата доставки визначається датою забору вантажу. Ми доставимо ваш вантаж максимально швидко, дотримуючись стандартного транзитного часу після забору. Для збірних вантажів ви також можете забронювати конкретну дату та час доставки, скориставшись послугою 'Вікно доставки', яка доступна для будь-якого тарифу. У цьому випадку ваш вантаж тимчасово зберігатиметься на нашому складі до узгодженої дати доставки.",
                "datePickerName": "Дата доставки",
                "cargoTimeName": "Час доставки",
                "switchName": "Обрати часи доставки"
            }
        },
        "card": {
            "internationalDeliveryLbl": "Міжнародна доставка"
        }
    },
    "verification": {
        "cargoDataCard": {
            "title": "Дані про вантаж (LTL)"
        }
    },
    "booking": {
        "loadingAddressCard": {
            "title": "Адреса завантаження"
        },
        "receivingAddress": {
            "title": "Адреса отримання"
        },
        "addToAddressBookLbl": "Додати до адресної книги",
        "addressChangedWarning": "При зміні адреси вартість доставки може змінитися"
    },
    "orderConfirmation": {
        "title": {
            "p1": "Вашу заявку успішно оформлено",
            "p2": "Після перевірки нашими спеціалістами, ви отримаєте підтвердження на електронну пошту"
        },
        "body": {
            "title": "Що далі?",
            "info": [
                {
                    "title": "Перевірка та підтверження замовлення",
                    "p": "Після цього ви отримаєте лист із підтвердженням на свій емейл."
                },
                {
                    "title": "Оплата замовлення",
                    "p": "Далі ми виставимо вам рахунок. Після оплати ваше замовлення буде підтверджено та взято до обробки."
                },
                {
                    "title": "Уточнення деталей ",
                    "p": "Наші фахівці зв'яжуться з вашим відправником та узгодять деталі відвантаження."
                },
                {
                    "title": "Перевірка докуметів",
                    "p": "Щоб у процесі доставки вантажу не виникало затримок, і в разі необхідності повідомимо вас про необхідні корекції."
                },
                {
                    "title": "Процес виконання замовлення",
                    "p": "Ви зможете відстежувати стан замовлення за трек-номером 24/7."
                },
                {
                    "title": "Перевірка докуметів",
                    "p": "Щоб у процесі доставки вантажу не виникало затримок, і в разі необхідності повідомимо вас про необхідні корекції."
                },
                {
                    "title": "Процес виконання замовлення",
                    "p": "Ви зможете відстежувати стан замовлення за трек-номером 24/7."
                }
            ]
        },
        "contacts": {
            "p1": "У вас залишились запитання?",
            "p2": "Зв'яжіться з нами зручним для вас способом"
        },
        "finalConfirmation": {
            "title": "Розкажіть нам про свій досвід",
            "rateExperienceTitle": "Оцініть свій останній досвід",
            "yourExperienceTitle": "Ваш відгук:",
            "notePlaceholder": "Тут ви пишете свій відгук. Поясніть, що трапилося, і не використовуйте образливі слова. Нехай ваш відгук буде чесним, корисним і конструктивним."
        }
    }
}